import React, {
    useContext,
    useState,
    useEffect,
    useCallback
} from 'react';
import {
    Switch, Route, Redirect, BrowserRouter as Router
} from 'react-router-dom';
import _ from 'lodash';
// Imported First to allow Jutro styles to be overridden
import './App.scss';
import { setComponentMapOverrides } from '@jutro/uiconfig';
import {
    Main,
    useModal,
    ModalNextEmitter
} from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { NavRoutes, routeConfirmationModal } from '@jutro/router';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { DynamicRoute, GrantedAuthorities, withAuthContextProvider } from 'gw-digital-auth-react';
import vmTranslator, { messages as commonMessages } from 'gw-platform-translations';
import { AccurateBreakpointPropagation } from 'gw-jutro-adapters-react';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import { ViewModelServiceFactory } from 'gw-portals-viewmodel-js';
import { PolicyDetails } from 'gw-capability-policy-react';
import { AvailabilityService } from 'gw-capability-policycommon';
import { EndorsementService } from 'gw-capability-policychange';
import { PAPolicyChangeWizard } from 'gw-capability-policychange-pa-react';
import { HOPolicyChangeWizard } from 'gw-capability-policychange-ho-react';
import { LoginCapabilityComponentMap, LoginCapabilityComponents } from 'gw-portals-login-react';
import { personalizedOfferComponentMap, personalizedOfferComponents } from 'gw-capability-personalizedoffers-react';
import { VehicleInfoLookupComponentMap, VehicleInfoLookupComponents } from 'gw-capability-vehicleinfo-react';
import { policyJobComponentMap, policyJobComponents } from 'gw-capability-policyjob-react';
import {
    BillingSummaryPage,
    MakePaymentPage,
    billingComponentMap,
    billingAdditionalComponents
} from 'gw-capability-billing-react';
import { AdditionalEnrollment, SignUpEnrollment, PdfCustomModal } from 'gw-capability-enrollment-react';
import { UsersProfile } from 'gw-capability-profileinfo-react';
import { WizardPageTemplateWithTitle } from 'gw-portals-wizard-components-ui';
import { ProducerInfoService } from 'gw-capability-profileinfo';

import { DependencyProvider } from 'gw-portals-dependency-react';
import { AccountBillingDetailsService, BillingService } from 'gw-capability-billing';
import { PolicyService } from 'gw-capability-policy';
import { ClaimDocumentService } from 'gw-capability-claimdocument';

import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import {
    platformComponentMap,
    platformComponents,
    ImageComponent,
} from 'gw-components-platform-react';
import { ErrorBoundary } from 'gw-portals-error-react';
import BaseFNOLWizard, { ClaimsConfirmationPage } from 'gw-capability-fnol-common-react';
import { ContactAgentPage } from 'gw-pages-platform-react';
import FNOLPAWizard from 'gw-capability-fnol-pa-react';
import FNOLWCWizard from 'gw-capability-fnol-wc-react';
import FNOLCAWizard from 'gw-capability-fnol-ca-react';
import FNOLHOWizard from 'gw-capability-fnol-ho-react';
import FNOLCPWizard from 'gw-capability-fnol-cp-react';
import FNOLBOPWizard from 'gw-capability-fnol-bop-react';
import FNOLGeneralWizard from 'gw-capability-fnol-gl-react';

import {
    ClaimList, ClaimDetails, PolicyLevelCoverages, CreateNote
} from 'gw-capability-claim-react';
import { ClaimService } from 'gw-capability-claim';
import { FNOLService } from 'gw-capability-fnol';
import FaqPage from 'gw-capability-faq-react';
import { PolicyDocumentError } from 'gw-capability-document-react';
import { filterCapabilityRoutes } from 'gw-portals-config-js';
import Recaptcha from 'react-recaptcha';
import { PDFViewer } from 'gw-document-pdfdisplay-react';
import UserApprovePage from '../pages/UserApprovePage/UserApprovePage';
import PageHeaderComponent from '../components/PageHeaderComponent/PageHeaderComponent';
import { routes } from './App.routes.metadata.json5';
import ResetPasswordPage from '../pages/ResetPasswordPage/ResetPasswordPage';
import EntryPage from '../pages/EntryPage/EntryPage';
import UserRegisterEntryPage from '../pages/UserRegisterEntryPage/UserRegisterEntryPage';
import LandingPage from '../pages/LandingPage/LandingPage';
import messages from './App.messages';

const { capabilitiesConfig } = appConfig;

const componentMap = {
    landingpage: LandingPage,
    policydocumenterror: PolicyDocumentError,
    fnolwcwizard: FNOLWCWizard,
    basefnolwizard: BaseFNOLWizard,
    claimsconfirmationpage: ClaimsConfirmationPage,
    contactagent: ContactAgentPage,
    fnolpawizard: FNOLPAWizard,
    fnolhowizard: FNOLHOWizard,
    additionalenrollmentpage: AdditionalEnrollment,
    claimlist: ClaimList,
    claimdetails: ClaimDetails,
    policydetailspage: PolicyDetails,
    papolicychangewizard: PAPolicyChangeWizard,
    hopolicychangewizard: HOPolicyChangeWizard,
    createnote: CreateNote,
    billingsummarypage: BillingSummaryPage,
    makepaymentpage: MakePaymentPage,
    usersprofile: UsersProfile,
    policylevelcoverages: PolicyLevelCoverages,
    faqpage: FaqPage,
    fnolcawizard: FNOLCAWizard,
    fnolcpwizard: FNOLCPWizard,
    fnolbopwizard: FNOLBOPWizard,
    fnolgeneralwizard: FNOLGeneralWizard,
    userApprovePage: UserApprovePage
};

const shouldRouteToSignUp = (authorities) => {
    const accountAuthorities = authorities.filter((authority) => authority.authorityType === 'ACCOUNT');
    // if user doesn't have ACCOUNT authorities it is supposed to be enrolled
    /* if (accountAuthorities.length === 0) {
        return <Redirect to="/signup-enrollment" />;
    } */
    return null;
};

setComponentMapOverrides(
    {
        ...platformComponentMap,
        ...personalizedOfferComponentMap,
        ...VehicleInfoLookupComponentMap,
        ...LoginCapabilityComponentMap,
        ...policyJobComponentMap,
        ...billingComponentMap,
        Recaptcha: { component: 'Recaptcha' },
        WizardPageTemplateWithTitle: { component: 'WizardPageTemplateWithTitle' },
        // replace the native IMG component with a proxied version
        img: { component: 'img' },
        PDFViewer: { component: 'PDFViewer' },
        PdfCustomModal: { component: 'PdfCustomModal' },
    },
    {
        ...platformComponents,
        ...personalizedOfferComponents,
        ...VehicleInfoLookupComponents,
        ...LoginCapabilityComponents,
        ...policyJobComponents,
        ...billingAdditionalComponents,
        Recaptcha: Recaptcha,
        WizardPageTemplateWithTitle,
        img: ImageComponent,
        PDFViewer,
        PdfCustomModal
    }
);

// (Router) Title is required and used for (Browser) title
// in a format of "${title} - ${appName}". In order to show
// the application name only, it needs to be an empty value.
const routesWithTitle = filterCapabilityRoutes(capabilitiesConfig, routes);
const routesWithoutTitle = routesWithTitle.map((route) => {
    return {
        ...route,
        title: ''
    };
});

const modalEmitter = new ModalNextEmitter();

function App() {
    const {
        showAlert
    } = useModal();

    const translator = useTranslator();
    const [viewModelService, setViewModelService] = useState(undefined);

    useEffect(() => {
        const translatorFn = vmTranslator(translator);
        import(
            /* webpackChunkName: "product-metadata" */
            // eslint-disable-next-line import/no-unresolved
            'product-metadata'
        ).then((productMetadata) => {
            const { default: result } = productMetadata;
            setViewModelService(
                ViewModelServiceFactory.getViewModelService(result, translatorFn)
            );
        });
    }, [translator]);

    const handleError = useCallback(() => {
        return showAlert({
            title: messages.error,
            message: messages.errorMessage,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    }, [showAlert]);

    return (
        <AccurateBreakpointPropagation>
            <DependencyProvider
                value={{
                    AccountBillingDetailsService: AccountBillingDetailsService,
                    PolicyService: PolicyService,
                    EndorsementService: EndorsementService,
                    AvailabilityService: AvailabilityService,
                    FNOLService: FNOLService,
                    ClaimService: ClaimService,
                    ClaimDownloadService: ClaimDocumentService,
                    BillingService: BillingService,
                    EnrollmentService: EnrollmentService,
                    ContactService: ProducerInfoService,
                }}
            >
                <ErrorBoundary onError={handleError}>
                    <ViewModelServiceContext.Provider value={viewModelService}>
                        <Router
                            basename="/account-management"
                            getUserConfirmation={
                                (message, callback) => {
                                    return routeConfirmationModal(message, callback, modalEmitter);
                                }
                            }
                        >
                            <Switch>
                                <Route exact path="/login-page" component={EntryPage} />
                                <Route exact path="/auth/register" component={UserRegisterEntryPage} />
                                <Route exact path="/auth/resetpassword" component={ResetPasswordPage} />
                                <Route exact path="/signup-enrollment" component={SignUpEnrollment} />
                                <DynamicRoute path="/">
                                    <GrantedAuthorities
                                        checkRenderBasedOnAuthorities={shouldRouteToSignUp}
                                    >
                                        <PageHeaderComponent routes={routesWithTitle} />
                                        <Main>
                                            <NavRoutes
                                                resolveComponentMap={componentMap}
                                                routes={routesWithoutTitle}
                                            />
                                        </Main>
                                    </GrantedAuthorities>
                                </DynamicRoute>
                            </Switch>
                        </Router>
                    </ViewModelServiceContext.Provider>
                </ErrorBoundary>
            </DependencyProvider>
        </AccurateBreakpointPropagation>
    );
}

export default withAuthContextProvider()(App);
